export const orientationExpenseFieldConfiguration = [
  {
    name: "driverFirstName",
    label: "Driver First Name",
    type: "text",
  },
  {
    name: "driverLastName",
    label: "Driver Last Name",
    type: "text",
  },
  {
    name: "expenseType",
    label: "Expense Type",
    type: "text",
    validation: {
      required: "Expense type is required",
    },
  },
  {
    name: "cost",
    label: "Cost",
    type: "number",
    validation: {
      required: "Cost is required",
      min: {
        value: 0,
        message: "Cost must be 0 or higher",
      },
    },
  },
  {
    name: "paidBy",
    label: "Paid By",
    type: "text",
    validation: {
      required: "Paid by is required",
    },
  },
  {
    name: "notes",
    label: "Notes",
    type: "text",
  },
  {
    name: "hotelDaysNeeded",
    label: "Hotel Days Needed",
    type: "text",
  },
];

export const orientationExpenseInitialValues = {
  driverFirstName: "",
  driverLastName: "",
  expenseType: "",
  cost: "",
  paidBy: "",
  notes: "",
  hotelDaysNeeded: "",
};
